import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Typography } from '@material-ui/core'

const AddToGroup = ({ selectedCount, onToggle }) => {
  const { formatMessage } = useIntl()

  const selectedLabel = formatMessage({ id: 'selected.label' }).toLowerCase()

  return (
    <div>
      <Typography
        className="text-14 text-primary font-500 cursor-pointer whitespace-nowrap"
        onClick={onToggle}
      >
        {formatMessage({
          id: 'subscriber.action.add.to.group',
        })}{' '}
        ({selectedCount.toLocaleString()} {selectedLabel})
      </Typography>
    </div>
  )
}

AddToGroup.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onToggle: PropTypes.func.isRequired,
}

export default AddToGroup
